import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {applicationHistory} from '../../common/application-history';
import UrlMappings from '../../common/url-mappings';
import {
    clearSelectedAlbums,
    addListToAlbum,
    deleteAlbums,
    addListToDvd,
    favoriteSelectedItems,
    selectAllAlbums
} from '../../album-view/actions/album-actions';

import {Dialog} from '../../common/components/dialog';
import SelectAlbumContent from '../../album-view/components/dialog/select-album-content';
import {AlbumDeleteDialog} from '../../album-view/components/dialog/album-delete-dialog';
import AddToDiscDialog from "../../disc/components/dialog/add-to-disc-dialog"
import ShareDialog from "../../common/components/share-dialog";
import MediaDownloadDialog from "../../album-view/components/dialog/media-download-dialog";
import ConfirmationDialog from "../../common/components/confirmation-dialog";
import AddToAlbumDialog from "../../album-view/components/dialog/add-to-album-dialog";

class AlbumSelectModeHeader extends Component {
    constructor(props) {
        super(props);

        this.cancelSelection = this.cancelSelection.bind(this);
        this.favoriteSelectedItems = this.favoriteSelectedItems.bind(this);
        this.addSelectedToAlbum = this.addSelectedToAlbum.bind(this);
        this.addSelectedToDisc = this.addSelectedToDisc.bind(this);
        this.deleteSelected = this.deleteSelected.bind(this);
        this.openSelectAlbumDialog = this.openSelectAlbumDialog.bind(this);
        this.closeSelectAlbumDialog = this.closeSelectAlbumDialog.bind(this);
        this.openSelectDiscDialog = this.openSelectDiscDialog.bind(this);
        this.closeSelectDiscDialog = this.closeSelectDiscDialog.bind(this);
        this.openDeleteDialog = this.openDeleteDialog.bind(this);
        this.closeDeleteDialog = this.closeDeleteDialog.bind(this);
        this.openShareDialog = this.openShareDialog.bind(this);
        this.openDownloadDialog = this.openDownloadDialog.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.deselectAll = this.deselectAll.bind(this);
        this.state = {
            isDeleteDialogOpen: false,
            isAddToAlbumDialogOpen: false,
            isAddToDiscDialogOpen: false,
            isShareDialogOpen: false,
            isDownloadDialogOpen: false,
        }
    }

    favoriteSelectedItems() {
        const {selectedAlbumIds, favoriteAlbums} = this.props;
        favoriteAlbums(selectedAlbumIds);
    }

    addSelectedToAlbum(albumId, deleteOriginal) {
        const {selectedAlbumIds, addAlbumsToAlbum} = this.props;
        addAlbumsToAlbum(albumId, selectedAlbumIds, deleteOriginal);
        alert("Your assets have been added to the album");
        this.setState({isAddToAlbumDialogOpen: false})
        this.cancelSelection()
        setTimeout(()=>applicationHistory.push(`/my/album/${albumId}`),100);
    }

    addSelectedToDisc(discId) {
        const {selectedAlbumIds, addAlbumsToDisc} = this.props;
        addAlbumsToDisc(discId, selectedAlbumIds);
        this.setState({isAddToDiscDialogOpen: false})
    }

    deleteSelected() {
        const {selectedAlbumIds, deleteAlbums} = this.props;
        deleteAlbums(selectedAlbumIds);
        this.setState({isDeleteDialogOpen: false})
    }

    cancelSelection() {
        const {clearAlbumSelection, disableAlbumSelectionMode} = this.props;
        clearAlbumSelection();
        disableAlbumSelectionMode();
        applicationHistory.push(UrlMappings.ALBUMS);
    }

    openDeleteDialog() {
        this.setState({isDeleteDialogOpen: true})
    }

    closeDeleteDialog() {
        this.setState({isDeleteDialogOpen: false})
    }

    openSelectAlbumDialog() {
        this.setState({isAddToAlbumDialogOpen: true})
    }

    closeSelectAlbumDialog() {
        this.setState({isAddToAlbumDialogOpen: false})
    }

    openSelectDiscDialog() {
        this.setState({isAddToDiscDialogOpen: true})
    }

    closeSelectDiscDialog() {
        this.setState({isAddToDiscDialogOpen: false})
    }

    openShareDialog() {
        this.setState({isShareDialogOpen: true})
    }

    openDownloadDialog() {
        this.setState({isDownloadDialogOpen: true})
    }

    selectAll() {
        this.props.selectAllAlbums();
    }

    deselectAll() {
        this.props.clearAlbumSelection();
    }

    render() {
        const numItemsSelected = this.props.selectedAlbumIds.length;

        return (
            <header className="select-mode header-flex-container">
                <div className="header-flex-left">
                    <div className="header-item header-item-left" onClick={this.cancelSelection}>
                        <div className="header-icon cancel"/>
                        <span className="cancel-text">Cancel</span>
                    </div>
                    {numItemsSelected === 0 ? (
                        <span className="album-items-selected-text header-item">Select Albums</span>
                    ) : (
                        <span/>
                    )}
                    {numItemsSelected > 0 ? (
                        <span
                            className="album-items-selected-text header-item"> {numItemsSelected} Items Selected</span>
                    ) : (
                        <span/>
                    )}
                </div>
                {}
                <div className="header-flex-right">

                    {/*{numItemsSelected === 1 &&*/}
                    {/*<div*/}
                    {/*	className="header-item header-item-right"*/}
                    {/*	onClick={this.favoriteSelectedItems}*/}
                    {/*>*/}
                    {/*	<div className="header-icon favorite"/>*/}
                    {/*	<div className="header-label">Favorite</div>*/}
                    {/*</div>*/}
                    {/*}*/}

                    {numItemsSelected > 0 &&
                        <div className="header-item header-item-right" onClick={this.openSelectAlbumDialog}>
                            <div className="header-icon add-to-album-white"/>
                            <div className="header-label">Add to Album</div>
                        </div>
                    }
                    {numItemsSelected === 1 &&
                        <div className="header-item header-item-right" onClick={this.openSelectDiscDialog}>
                            <div className="header-icon disc-white"/>
                            <div className="header-label">Add to Disc</div>
                        </div>
                    }
                    {numItemsSelected > 0 &&
                        <div className="header-item header-item-right" onClick={this.openDeleteDialog}>
                            <div className="header-icon delete-white"/>
                            <div className="header-label">Delete</div>
                        </div>
                    }
                    {numItemsSelected > 0 &&
                        <div className="header-item header-item-right" onClick={this.openShareDialog}>
                            <div className="header-icon share-white"/>
                            <div className="header-label">Share</div>
                        </div>
                    }
                    {numItemsSelected > 0 && this.props.downloadEnabled &&
                        <div className="header-item header-item-right" onClick={this.openDownloadDialog}>
                            <div className="header-icon download-white"/>
                            <div className="header-label">Download</div>
                        </div>
                    }
                    {numItemsSelected > 0 &&
                        <div className="header-item header-item-right" onClick={this.deselectAll}>
                            <div className="header-icon select-dark"/>
                            <div className="header-label">Deselect All</div>
                        </div>
                    }
                    {numItemsSelected < this.props.albums.length &&
                        <div className="header-item header-item-right" onClick={this.selectAll}>
                            <div className="header-icon select-dark"/>
                            <div className="header-label">Select All</div>
                        </div>
                    }
                </div>
                {this.state.isAddToDiscDialogOpen &&
                    <AddToDiscDialog isOpen={this.state.isAddToDiscDialogOpen}
                                     onClose={() => this.setState({isAddToDiscDialogOpen: false})}
                                     canCancel={true}
                                     album={this.props.albums.filter(album => album.id == this.props.selectedAlbumIds[0])[0]}
                    />
                }
                {this.state.isAddToAlbumDialogOpen &&
                    <AddToAlbumDialog isOpen={this.state.isAddToAlbumDialogOpen}
                                      canCancel={true}
                                      showDeleteOriginal={true}
                                      albums={this.props.albums.filter(album => {
                                          for (let i = 0; i < this.props.selectedAlbumIds.length; i++) {
                                              if (album.id == this.props.selectedAlbumIds[i]) {
                                                  return false;
                                              }
                                          }
                                          return true;
                                      })}
                                      onClose={() => this.setState({isAddToAlbumDialogOpen: false})}
                                      onAlbumSelected={(album, deleteOriginal) => this.addSelectedToAlbum(album.id, deleteOriginal)}/>
                }
                {this.state.isDeleteDialogOpen &&
                    <ConfirmationDialog title={"Delete Album"}
                                        message={"Are you sure you want to delete " + (this.props.selectedAlbumIds.length == 1 ? "this album" : "these " + this.props.selectedAlbumIds.length + " albums") + "?"}
                                        isOpen={this.state.isDeleteDialogOpen}
                                        onYesAction={this.deleteSelected}
                                        onNoAction={() => this.setState({isDeleteDialogOpen: false})}/>
                }
                {this.state.isShareDialogOpen &&
                    <ShareDialog identifier={this.props.selectedAlbumIds}
                                 onClose={() => this.setState({isShareDialogOpen: false})}
                                 isOpen={this.state.isShareDialogOpen}
                                 multipleAssets={true}
                                 type="ccs"
                    />
                }
                {this.state.isDownloadDialogOpen &&
                    <MediaDownloadDialog
                        onClose={() => this.setState({isDownloadDialogOpen: false})}
                        isOpen={this.state.isDownloadDialogOpen}
                        type="ccs"
                        ccs={this.props.selectedAlbumIds}
                    />
                }
            </header>
        );
    }
}

AlbumSelectModeHeader.propTypes = {
    clearAlbumSelection: PropTypes.func,
    disableAlbumSelectionMode: PropTypes.func,
    favoriteAlbums: PropTypes.func,
    selectedAlbumIds: PropTypes.array,
    addAlbumsToAlbum: PropTypes.func,
    addAlbumsToDisc: PropTypes.func,
    deleteAlbums: PropTypes.func,
    downloadEnabled: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        selectedAlbumIds: state.albumList.albums.filter(itm => {
            return itm.selected;
        }).map(itm => itm.id),
        albums: state.albumList.albums,
        downloadEnabled: state.cart.orderType !== "RPC" && (state.settings.attributes["web.download.allow"] == null || state.settings.attributes["web.download.allow"] !== "false")
    };
};

const mapDispatchToProps = dispatch => {
    return {
        favoriteAlbums: albums => dispatch(favoriteSelectedItems(dispatch, albums)),
        addAlbumsToAlbum: (targetAlbumId, albums, deleteOriginal) => dispatch(addListToAlbum(dispatch, targetAlbumId, albums, deleteOriginal)),
        addAlbumsToDisc: (targetDiscId, albums) => dispatch(addListToDvd(dispatch, targetDiscId, albums)),
        deleteAlbums: albums => dispatch(deleteAlbums(dispatch, albums)),
        clearAlbumSelection: () => dispatch(clearSelectedAlbums()),
        selectAllAlbums: () => dispatch(selectAllAlbums())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AlbumSelectModeHeader);



// WEBPACK FOOTER //
// ./src/header/components/album-select-mode-header.jsx